import { MockServiceStore } from "./MockServiceStore";

/**
 * StructureCast - Purchase Order Line Item
 *
 * One row per material on a PO. `materialCode` optionally links back to a
 * RawMaterial in the inventory mock so receiving can auto-adjust stock.
 */
export interface StructureCastPurchaseOrderLineItem {
  id: string;
  purchaseOrderId: string;
  materialCode: string; // optional FK to RawMaterial.materialCode
  description: string;
  quantity: number;
  unit: string;
  unitCost: number;
  total: number;
  receivedQuantity: number;
  notes: string;
  createdAt: string;
  updatedAt: string;
}

export const mockStructureCastPurchaseOrderLineItems: StructureCastPurchaseOrderLineItem[] = [
  // ── PO-2026-001: Alhambra Foundry Co. (closed) ────────────────────────
  {
    id: "sc-poli-001",
    purchaseOrderId: "sc-po-1",
    materialCode: "FRAME-1900",
    description: "1900 Sanitary Sewer CPH Frame (Alhambra Foundry)",
    quantity: 10,
    unit: "ea",
    unitCost: 195.0,
    total: 1950.0,
    receivedQuantity: 10,
    notes: "Gray iron ASTM A-48 CL 35B. H20 wheel loading.",
    createdAt: "2025-12-15T00:00:00.000Z",
    updatedAt: "2026-01-03T00:00:00.000Z",
  },
  {
    id: "sc-poli-002",
    purchaseOrderId: "sc-po-1",
    materialCode: "COVER-1900",
    description: "1900 Sanitary Sewer CPH Cover (Alhambra Foundry)",
    quantity: 10,
    unit: "ea",
    unitCost: 205.0,
    total: 2050.0,
    receivedQuantity: 10,
    notes: "",
    createdAt: "2025-12-15T00:00:00.000Z",
    updatedAt: "2026-01-03T00:00:00.000Z",
  },

  // ── PO-2026-002: NPC Inc (sent) ───────────────────────────────────────
  {
    id: "sc-poli-003",
    purchaseOrderId: "sc-po-2",
    materialCode: "BOOT-HWB10",
    description: "Press-Seal HWB 10\" Cast-In Pipe Boot (S106)",
    quantity: 10,
    unit: "ea",
    unitCost: 88.0,
    total: 880.0,
    receivedQuantity: 0,
    notes: "Critical reorder — running tight against Group 2 reservation.",
    createdAt: "2026-01-22T00:00:00.000Z",
    updatedAt: "2026-01-22T00:00:00.000Z",
  },

  // ── PO-2026-003: Concrete Sealants Inc (partial) ──────────────────────
  {
    id: "sc-poli-004",
    purchaseOrderId: "sc-po-3",
    materialCode: "SEAL-CS102",
    description: "CS-102 Butyl Sealant 1-1/8\"x14.5' (roll)",
    quantity: 24,
    unit: "rolls",
    unitCost: 18.0,
    total: 432.0,
    receivedQuantity: 18,
    notes: "Received 18, back-ordered 6 (ETA 2/5).",
    createdAt: "2026-01-12T00:00:00.000Z",
    updatedAt: "2026-01-22T00:00:00.000Z",
  },

  // ── PO-2026-004: CalPortland (draft) ──────────────────────────────────
  {
    id: "sc-poli-005",
    purchaseOrderId: "sc-po-4",
    materialCode: "CONC-5000",
    description: "5,000 PSI Concrete Mix (5,000 PSI Type II/V)",
    quantity: 30,
    unit: "CY",
    unitCost: 210.0,
    total: 6300.0,
    receivedQuantity: 0,
    notes: "Group 3 + Group 4 pour schedule. Same-day delivery, 24-hr notice.",
    createdAt: "2026-01-28T00:00:00.000Z",
    updatedAt: "2026-01-28T00:00:00.000Z",
  },
  {
    id: "sc-poli-006",
    purchaseOrderId: "sc-po-4",
    materialCode: "FIB-POLY",
    description: "Polypropylene Concrete Fibers — included with mix",
    quantity: 100,
    unit: "lbs",
    unitCost: 1.5,
    total: 150.0,
    receivedQuantity: 0,
    notes: "Caltrans secondary reinforcing spec.",
    createdAt: "2026-01-28T00:00:00.000Z",
    updatedAt: "2026-01-28T00:00:00.000Z",
  },

  // ── PO-2026-005: Coast Steel & Rebar (acknowledged) ───────────────────
  {
    id: "sc-poli-007",
    purchaseOrderId: "sc-po-5",
    materialCode: "RBR-4-A615",
    description: "#4 Rebar ASTM A-706/A-615 Gr 60 (1/2\")",
    quantity: 1200,
    unit: "lf",
    unitCost: 0.88,
    total: 1056.0,
    receivedQuantity: 0,
    notes: "Pre-cut to 20-ft lengths.",
    createdAt: "2026-01-20T00:00:00.000Z",
    updatedAt: "2026-01-21T00:00:00.000Z",
  },
  {
    id: "sc-poli-008",
    purchaseOrderId: "sc-po-5",
    materialCode: "RBR-6-A615",
    description: "#6 Rebar ASTM A-706/A-615 Gr 60 (3/4\")",
    quantity: 600,
    unit: "lf",
    unitCost: 1.7,
    total: 1020.0,
    receivedQuantity: 0,
    notes: "",
    createdAt: "2026-01-20T00:00:00.000Z",
    updatedAt: "2026-01-21T00:00:00.000Z",
  },
];

export const createMockStructureCastPurchaseOrderLineItemStore = () =>
  new MockServiceStore<StructureCastPurchaseOrderLineItem>({
    mockData: mockStructureCastPurchaseOrderLineItems,
    idField: "id",
    simulateDelay: 200,
    persistKey: "preferred-structurecast-purchase-order-line-items",
  });

export default mockStructureCastPurchaseOrderLineItems;
